/* DarthDabs — PDP JS
   - Gallery thumbnail swap + prev/next nav buttons
   - Click main image → lightbox (with prev/next when multiple images)
   - Mobile sticky ATC via IntersectionObserver
   - Variant picker wiring (select → hidden id, price, availability, image)
   Vanilla, no deps. */
(function () {
  'use strict';

  // ---- Gallery state ----
  var gallery = document.querySelector('[data-dd-gallery]');
  var mainImg = gallery && gallery.querySelector('[data-dd-main-img]');
  var thumbs = gallery ? Array.prototype.slice.call(gallery.querySelectorAll('[data-dd-thumb]')) : [];
  var activeIndex = Math.max(0, thumbs.findIndex(function(t) { return t.classList.contains('is-active'); }));

  // Gallery prev/next nav buttons
  var galleryPrev = gallery && gallery.querySelector('[data-dd-gallery-prev]');
  var galleryNext = gallery && gallery.querySelector('[data-dd-gallery-next]');

  function updateGalleryNav() {
    if (!galleryPrev || !galleryNext) return;
    galleryPrev.disabled = activeIndex <= 0;
    galleryNext.disabled = activeIndex >= thumbs.length - 1;
  }

  function setActive(i) {
    if (i < 0 || i >= thumbs.length) return;
    var t = thumbs[i];
    var full = t.getAttribute('data-full');
    var srcset = t.getAttribute('data-srcset');
    var alt = t.getAttribute('data-alt');
    if (full && mainImg) {
      mainImg.src = full;
      if (srcset) mainImg.srcset = srcset;
      else mainImg.removeAttribute('srcset');
      mainImg.alt = alt || '';
    }
    thumbs.forEach(function (x, idx) {
      var on = idx === i;
      x.classList.toggle('is-active', on);
      x.setAttribute('aria-selected', on ? 'true' : 'false');
    });
    activeIndex = i;
    updateGalleryNav();
    // Keep lightbox in sync if open.
    if (lb && !lb.hidden && lbImg && full) {
      lbImg.src = full;
      lbImg.alt = alt || '';
      updateLBNav();
    }
  }

  thumbs.forEach(function (t, i) {
    t.addEventListener('click', function () { setActive(i); });
  });

  if (galleryPrev) {
    galleryPrev.addEventListener('click', function (e) {
      e.stopPropagation();
      setActive(activeIndex - 1);
    });
  }
  if (galleryNext) {
    galleryNext.addEventListener('click', function (e) {
      e.stopPropagation();
      setActive(activeIndex + 1);
    });
  }

  // Init nav state on load
  updateGalleryNav();

  // ---- Lightbox ----
  var lb = document.querySelector('[data-dd-lightbox]');
  var lbImg = lb && lb.querySelector('[data-dd-lightbox-img]');
  var lbTrigger = document.querySelector('[data-dd-lightbox-trigger]');
  var lbClose = lb && lb.querySelector('[data-dd-lightbox-close]');
  var lbPrev = lb && lb.querySelector('[data-dd-lightbox-prev]');
  var lbNext = lb && lb.querySelector('[data-dd-lightbox-next]');
  var lbPreviousFocus = null;
  var lbPreviousOverflow = '';

  function updateLBNav() {
    if (!lbPrev || !lbNext) return;
    var multi = thumbs.length > 1;
    lbPrev.style.display = multi ? '' : 'none';
    lbNext.style.display = multi ? '' : 'none';
    lbPrev.disabled = activeIndex <= 0;
    lbNext.disabled = activeIndex >= thumbs.length - 1;
  }
  function openLB() {
    if (!lb || !lbImg || !mainImg) return;
    if (!lb.hidden) return;
    lbPreviousFocus = document.activeElement;
    lbPreviousOverflow = document.body.style.overflow;
    lbImg.src = mainImg.src;
    lbImg.alt = mainImg.alt || '';
    lb.hidden = false;
    document.body.style.overflow = 'hidden';
    updateLBNav();
    (lbClose || lb).focus();
  }
  function closeLB() {
    if (!lb || lb.hidden) return;
    lb.hidden = true;
    document.body.style.overflow = lbPreviousOverflow;
    if (lbPreviousFocus && document.contains(lbPreviousFocus)) lbPreviousFocus.focus();
    lbPreviousFocus = null;
  }
  if (lbTrigger) lbTrigger.addEventListener('click', openLB);
  if (lbClose) lbClose.addEventListener('click', closeLB);
  if (lbPrev) lbPrev.addEventListener('click', function () { setActive(activeIndex - 1); });
  if (lbNext) lbNext.addEventListener('click', function () { setActive(activeIndex + 1); });
  if (lb) lb.addEventListener('click', function (e) { if (e.target === lb) closeLB(); });
  document.addEventListener('keydown', function (e) {
    if (!lb || lb.hidden) return;
    if (e.key === 'Escape') closeLB();
    if (e.key === 'ArrowLeft') setActive(activeIndex - 1);
    if (e.key === 'ArrowRight') setActive(activeIndex + 1);
    if (e.key === 'Tab') {
      var focusable = Array.prototype.filter.call(lb.querySelectorAll('button:not([disabled])'), function(el) { return el.getClientRects().length > 0; });
      var first = focusable[0], last = focusable[focusable.length - 1];
      if (first && (!lb.contains(document.activeElement) || (!e.shiftKey && document.activeElement === last))) {
        e.preventDefault(); first.focus();
      } else if (last && e.shiftKey && document.activeElement === first) {
        e.preventDefault(); last.focus();
      }
    }
  });

  // ---- Mobile sticky ATC ----
  var atc = document.querySelector('[data-dd-atc]');
  var stuck = document.querySelector('[data-dd-stuck]');
  var stuckBtn = stuck && stuck.querySelector('[data-dd-stuck-atc]');
  if (atc && stuck && 'IntersectionObserver' in window) {
    stuck.hidden = false;
    stuck.inert = true;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var hide = entry.isIntersecting;
        stuck.classList.toggle('is-visible', !hide);
        stuck.setAttribute('aria-hidden', hide ? 'true' : 'false');
        stuck.inert = hide;
      });
    }, { threshold: 0.1 });
    io.observe(atc);

    if (stuckBtn) {
      stuckBtn.addEventListener('click', function () {
        if (atc.disabled) return;
        atc.click();
      });
    }
  }

  // ---- Variant selection ----
  var vSelect = document.querySelector('[data-dd-variant-select]');
  var vId = document.querySelector('[data-dd-variant-id]');
  if (vSelect && vId) {
    var priceEls = Array.prototype.slice.call(document.querySelectorAll('[data-dd-price]'));
    var stuckPrice = document.querySelector('[data-dd-stuck-price]');
    var atcBtn = document.querySelector('[data-dd-atc]');
    var stuckAtcBtn = document.querySelector('[data-dd-stuck-atc]');

    var applyVariant = function (swapMedia) {
      var opt = vSelect.options[vSelect.selectedIndex];
      if (!opt) return;
      vId.value = opt.value;
      var price = opt.getAttribute('data-price');
      var available = opt.getAttribute('data-available') === 'true';
      var media = opt.getAttribute('data-media');
      if (price) {
        priceEls.forEach(function (el) { el.textContent = price; });
        if (stuckPrice) stuckPrice.textContent = price;
      }
      [atcBtn, stuckAtcBtn].forEach(function (btn) {
        if (!btn) return;
        btn.disabled = !available;
        btn.textContent = available ? 'Add to Cart' : 'Sold';
      });
      if (swapMedia && media && mainImg) {
        var mediaPath = function(url) { if (!url) return null; try { return new URL(url, location.href).pathname; } catch (e) { return url; } };
        var thumbIndex = thumbs.findIndex(function(t) { return mediaPath(t.getAttribute('data-full')) === mediaPath(media); });
        if (thumbIndex >= 0) {
          // The gallery owns the matching src, responsive candidates and alt text.
          setActive(thumbIndex);
        } else if (mediaPath(mainImg.getAttribute('src')) !== mediaPath(media)) {
          // A variant image outside the gallery has no matching responsive set or
          // description. Do not retain metadata or a selected tab for another image.
          mainImg.src = media;
          mainImg.removeAttribute('srcset');
          mainImg.alt = '';
          thumbs.forEach(function(t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          activeIndex = -1;
          updateGalleryNav();
          if (lb && !lb.hidden && lbImg) {
            lbImg.src = media;
            lbImg.alt = '';
            updateLBNav();
          }
        }
      }
    };

    vSelect.addEventListener('change', function () { applyVariant(true); });
    applyVariant(true);
  }
})();
